import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { isMobile } from "react-device-detect";
import Typography from "@mui/material/Typography";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import "./App.css";
import { BING_API_KEY } from "./constants";
// InputLabel,
// Input,
// FormHelperText,
// FormLabel,
// Radio,
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  TextField,
  Checkbox,
  Button,
} from "@mui/material";
// import axios from "axios";
import axios from "axios";
// import { FormControl,  } from '@mui/material';.

// const DATA_CACHE_NAME = "data-cache";
import localforage from "localforage";

const YourTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "&:hover, &.Mui-focused, &.Mui-focused:hover": {
      borderColor: "gray",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "gray",
  },
});
function Survey({ setshowSuccess, showSuccess, selectedUser }) {
  const syncInProgress = useRef(false);
  const [any, setAny] = useState(null);
  const navigate = useNavigate();
  const [lt, setLt] = useState("");
  const [ln, setLn] = useState("");
  const [nearest, setNearest] = useState([]);
  const [coordinates, setCoordinates] = useState([]);

  const [address, setAddress] = useState("");
  const [selectedValue, setSelectedValue] = useState([]);
  const [notes, setNotes] = useState("");
  const [contamination, setContamination] = useState("");
  const [imageSrc, setImageSrc] = useState(null);
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);
  const [localData, setLocalData] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const ResetForm = () => {
    setAddress("");
    setSelectedValue("");
    setNotes("");
    setContamination("");
    setImageSrc("");
    navigate("/");
  };

  // const handleDisable = () => {
  //   if (
  //     setAddress("") ||
  //     setSelectedValue("") ||
  //     setNotes("") ||
  //     setContamination("") ||
  //     setImageSrc("")
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    // Check if the value is already in the array
    if (selectedValue.includes(value)) {
      setSelectedValue(selectedValue.filter((item) => item !== value));
    } else {
      setSelectedValue([...selectedValue, value]);
    }
  };
  const url = `https://perchtech.co/version-test/api/1.1/obj/activities2`;

  // const url = `https://sty1.sty-server.com/pwatest/`;

  const token = `2782b47897f0278c7a1d85703cd7e85e`;

  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsButtonDisabled(true);

    const selectedAddress = nearest?.find(
      (single_address) => single_address.address === address
    );
    let citiesToCheck = [
      "Madera",
      "Mill Valley",
      "Tiburon",
      "Menlo Park",
      "Larkspur",
    ];
    let city = citiesToCheck.find((cityToCheck) =>
      address.includes(cityToCheck)
    );

    // console.log(city);

    let data = {
      ActivityType: "Sty-Contaminated",
      City: city ? city : address,
      Contaminants: [...selectedValue, contamination],
      Creator: selectedUser,
      "Image URL": imageSrc,
      "Lat/Long": lt + "," + ln,
      Notes: notes,
      UniqueCustomerID: selectedAddress?.UniqueCustomerID,
    };

    // console.log(data);

    // return false;

    if (window.navigator.onLine) {
      // Check if there's offline data to submit
      if ("serviceWorker" in navigator && "SyncManager" in window) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.sync.register("submitOfflineData");
        });
      }
      let response;
      try {
        response = await axios.post(url, data, headers);
        console.log("data=>>>>>>>>>>", data);
        console.log(response.data);
      } catch (error) {
        console.log("not posted ,", error);
      }

      if (response.status === 201) {
        setshowSuccess(true);
        navigate("/", { state: { currentUser: selectedUser } });

        setIsButtonDisabled(false);
      } else {
        return false;
      }
    } else {
      // Storing data in cache
      // Store data

      // Storing data in localforage

      if (isMobile()) {
        try {
          // Retrieve existing data from localforage
          const existingData = await localforage.getItem("offlineData");

          // Create a new array or use an empty array if there's no existing data
          const newDataArray = existingData ? [...existingData, data] : [data];

          // Store the updated array back in localforage
          await localforage.setItem("offlineData", newDataArray);
        } catch (error) {
          console.error("Error storing data:", error);
        }
      }

      if (!isMobile() && typeof localStorage !== "undefined") {
        try {
          const localStrategy = localStorage.getItem("offlineData");
          const offlineData = localStrategy ? JSON.parse(localStrategy) : [];
          offlineData.push(data);
          localStorage.setItem("offlineData", JSON.stringify(offlineData));
        } catch (error) {
          console.error("Error storing data:", error);
        }
      }

      setshowSuccess(true);
      navigate("/", { state: { currentUser: selectedUser } });

      setIsButtonDisabled(false);
      return false;
    }

    return false;
    // Form submission logic here
  };

  useEffect(() => {
    if (showSuccess) {
      navigate("/");
    }
  }, [showSuccess]);
  // useEffect to check and sync offline data when online
  useEffect(() => {
    const syncAndClearLocalStorage = async () => {
      const offlineData = JSON.parse(localStorage.getItem("offlineData")) || [];

      if (
        !syncInProgress.current &&
        offlineData.length > 0 &&
        window.navigator.onLine
      ) {
        // Set the sync in progress to prevent further executions
        syncInProgress.current = true;

        for (const data of offlineData) {
          try {
            const response = await axios.post(url, data, headers);

            if (response.status === 201) {
              const updatedOfflineData = offlineData.filter(
                (item) => item.id !== data.id
              );
              localStorage.setItem(
                "offlineData",
                JSON.stringify(updatedOfflineData)
              );
            }
          } catch (error) {
            console.error("Error syncing offline data:", error);
          }
        }

        // Clear only the items that were successfully synced
        const updatedOfflineData =
          JSON.parse(localStorage.getItem("offlineData")) || [];
        localStorage.setItem("offlineData", JSON.stringify(updatedOfflineData));

        // Reset the sync in progress
        syncInProgress.current = false;
      }
    };

    syncAndClearLocalStorage();
  }, []);

  useEffect(() => {
    const syncAndClearLocalForage = async () => {
      const offlineData = (await localforage.getItem("offlineData")) || [];

      if (offlineData.length > 0 && window.navigator.onLine) {
        for (const data of offlineData) {
          try {
            const response = await axios.post(url, data, headers);

            if (response.status === 201) {
              const updatedOfflineData = offlineData.filter(
                (item) => item.id !== data.id
              );
              const res = await localforage.setItem(
                "offlineData",
                updatedOfflineData
              );
              setAny(res.data);
            }
          } catch (error) {
            console.error("Error syncing offline data:", error);
          }
        }

        // After syncing, clear LocalForage
        await localforage.removeItem("offlineData");
      }
    };

    syncAndClearLocalForage();
  }, []);

  // const isEmailValid = (email) => {
  //   return /\S+@\S+\.\S+/.test(email);
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageSrc(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const isMobile = () => {
    // Check if the viewport width is below a certain threshold
    return window.innerWidth <= 800; // Adjust the threshold based on your needs
  };

  /*  */
  function areCoordinatesMatching(coord1, coord2, threshold = 0.0001) {
    const [lat1, lon1] = coord1.split(",").map(Number);
    const [lat2, lon2] = coord2.split(",").map(Number);

    return (
      Math.abs(lat1 - lat2) < threshold && Math.abs(lon1 - lon2) < threshold
    );
  }
  /*  */

  function haversineDistance(coords1, coords2) {
    const toRad = (x) => (x * Math.PI) / 180;
    const R = 6371; // Earth radius in km

    const dLat = toRad(coords2.lat - coords1.lat);
    const dLon = toRad(coords2.lng - coords1.lng);

    const lat1 = toRad(coords1.lat);
    const lat2 = toRad(coords2.lat);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  /*  */

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;

          setLt(latitude);
          setLn(longitude);
        },
        (error) => {
          // console.log(error);
          console.error(`Error getting location: ${error.message}`);
        }
      );
    } else {
      alert("location denied");
      console.error("Geolocation is not supported by this browser.");
    }

    // const coordToMatch = "37.927036,-122.527626";

    const referencePoint = { lat: lt, lng: ln };

    fetch("address.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        data.forEach((item) => {
          const [lat, lng] = item.coordinates.split(",").map(Number);
          item.parsedCoordinates = { lat, lng };
        });

        const sortedByDistance = data
          .map((item) => ({
            ...item,
            distance: haversineDistance(referencePoint, item.parsedCoordinates),
          }))
          .sort((a, b) => a.distance - b.distance)
          .slice(0, 8);

        setNearest(sortedByDistance);
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  }, []);

  useEffect(() => {
    // Define the reverseGeocode function
    const reverseGeocode = (location, callback) => {
      // console.log("in reverse geocode function");
      var requestUrl = `https://dev.virtualearth.net/REST/v1/Locations/${location.latitude},${location.longitude}?key=${BING_API_KEY}`;

      fetch(requestUrl)
        .then((response) => response.json())
        .then(callback)
        .catch((error) => console.error("Error:", error));
    };

    window.navigator.onLine &&
      lt !== "" &&
      ln !== "" &&
      reverseGeocode({ latitude: lt, longitude: ln }, function (result) {
        // console.log("reverseGeocode12312");

        // Log the location details
        // console.log("Location Name:", result.resourceSets[0].resources[0].name);
        result.resourceSets[0].resources[0].name &&
          setAddress(result.resourceSets[0].resources[0].name);
        // console.log("Latitude:", lt);
        // console.log("Longitude:", ln);
      });
    // Add more details as needed
  }, [lt, ln]);

  const handleSelectNearbyAddress = () => {
    // Check if there are nearest addresses available
    if (nearest.length > 0) {
      // Set the selected address in the state without submitting the form
      setAddress(nearest[0].address);
    }
  };

  const handleRedirect = () => {
    navigate("/");
  };

  return (
    <div>
      <div>
        {/* {nearest.map((item, index) => (
            <div key={index}>
              <h3>{item.address}</h3>
              <p>Coordinates: {item.coordinates}</p>
              <p>Unique Customer ID: {item["UniqueCustomerID-TEST"]}</p>
            </div>
          ))} */}
      </div>

      <form onSubmit={handleSubmit}>
        <div className="close-icon-container">
          <CloseIcon sx={{ fontSize: "35px" }} onClick={handleRedirect} />
        </div>
        <div
          style={{
            backgroundColor: "#E3E1E1",
            height: "5px",
            width: "3.5rem",
            margin: "auto",
            borderRadius: "12px",
          }}
        />

        <FormControl component="fieldset" className="form">
          <input
            type="file"
            ref={fileInputRef}
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: "none" }}
            capture={isMobile() ? "camera" : ""}
          />

          <label style={{ marginLeft: "6px", fontSize: "20px" }}>Image</label>
          {/* <img
              onClick={handleClick}
              width={50}
              height={50}
              style={{ backgroundColor: "#ABA4A4" }}
              src="/assets/camera.png"
              alt=""
            /> */}
          <CameraAltIcon
            sx={{ fontSize: "50px", color: "#ABA4A4" }}
            onClick={handleClick}
          />
          <div className={`image-holder ${imageSrc ? "" : "hidden"} `}>
            {imageSrc && <img src={imageSrc} alt="Uploaded" />}
          </div>

          <div className="fileds-container">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "20px",
              }}
            >
              <label style={{ fontSize: "20px" }}>Enter address</label>
              <input
                className="last_inputs"
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                style={{
                  fontSize: "20px",
                  minHeight: "40px",
                  maxHeight: "40px",
                }}
              />
            </div>

            <div
              style={{
                margin: "10px 0",
                display: "flex",
                justifyItems: "center",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {/* <span
                style={{
                  backgroundColor: "lightgray",
                  height: "12px",
                  width: "12px",

                  display: "inline-block",
                  borderRadius: "50%",
                }}
              ></span> */}
              <button
                onClick={handleSelectNearbyAddress}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                type="button"
              >
                or select address nearby:
              </button>
            </div>

            <ul style={{ margin: "0px", padding: "0px" }}>
              {nearest.map((item, index) => (
                <li
                  style={{ cursor: "pointer" }}
                  onClick={() => setAddress(item.address)}
                  key={index}
                >
                  {item.address}
                </li>
              ))}
            </ul>

            <RadioGroup
              aria-label="options"
              name="options1"
              value={selectedValue}
              style={{ marginTop: "15px" }}
              // onChange={handleRadioChange}
            >
              <Typography
                variant="h6"
                component="h6"
                sx={{ fontWeight: "400" }}
              >
                Choose contaminants
              </Typography>

              <label
                className="radio-label"
                style={{ display: "flex", alignItems: "center" }}
              >
                <FormControlLabel
                  value="plastic bags"
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 33 },
                        color: "black",
                      }}
                    />
                  }
                  onChange={handleRadioChange}
                />
                <p>plastic bags</p>
              </label>
              <label className="radio-label">
                <FormControlLabel
                  value="food waste"
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 33 },
                        color: "black",
                      }}
                    />
                  }
                  onChange={handleRadioChange}
                />
                <p>food waste</p>
              </label>

              <label className="radio-label">
                <FormControlLabel
                  value="styrofoam"
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 33 },
                        color: "black",
                      }}
                    />
                  }
                  onChange={handleRadioChange}
                />
                <p>styrofoam</p>
              </label>

              <label className="radio-label">
                <FormControlLabel
                  value="non-recyclable plastics"
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 33 },
                        color: "black",
                      }}
                    />
                  }
                  onChange={handleRadioChange}
                />
                <p>non-recyclable plastics</p>
              </label>
            </RadioGroup>

            <div
              style={{
                marginTop: "15px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label style={{ fontSize: "20px" }}>Other contaminants</label>

              <textarea
                className="last_inputs"
                type="text"
                value={contamination}
                onChange={(e) => setContamination(e.target.value)}
              />
            </div>

            <div
              style={{
                marginTop: "14px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label style={{ fontSize: "20px" }}>Additional Notes</label>
              <textarea
                className="last_inputs"
                type="text"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>
          <br />
          <div className={`${!isMobile() ? "last-active" : "Mobile-div"}`}>
            {any}
            <Button
              className={`cancel-btn `}
              type="reset"
              variant="contained"
              style={{
                backgroundColor: "#3D3D3D",
                ...(isMobile()
                  ? { padding: "7px 30px" }
                  : { padding: "7px 40px" }),
                letterSpacing: "1.3px",
                opacity: "0.3",
                fontWeight: "600px",
                fontSize: "20px",
              }}
              onClick={ResetForm}
            >
              <span style={{ textTransform: "none" }}>Cancel</span>
            </Button>
            {imageSrc && (
              <Button
                className={`sumbit-btn `}
                type="submit"
                variant="contained"
                disabled={isButtonDisabled}
                style={{
                  backgroundColor: "#3D3D3D",
                  ...(isMobile()
                    ? { padding: "7px 30px" }
                    : { padding: "7px 40px" }),
                  fontWeight: "600px",
                  fontSize: "20px",
                  letterSpacing: "1.3px",
                }}
              >
                <span style={{ textTransform: "none" }}>Submit</span>
              </Button>
            )}
          </div>
        </FormControl>
        {imageSrc || isMobile() ? "" : <hr className="last-hr" />}
      </form>

      {/* <div>
          {window.navigator.onLine &&
            localData &&
            JSON.stringify(localData)?.substring(0, 40)}
        </div> */}
    </div>
  );
}

export default Survey;
